import { useEffect } from 'react';
import Smartlook from 'smartlook-client';

import { useHasSettings } from 'features/auth';
import { ToastContainer } from 'lib/toast';
import { FEATURE_FLAG } from 'types/featureFlag';

import { Toaster as SonnerToaster } from './components/ui/sonner';
import './App.css';
import { envConfig } from './config';
import { AppProvider } from './providers/app';
import { AppRoutes } from './routes';

import 'react-datepicker/dist/react-datepicker.css';
import '@assistant-ui/react/styles/index.css';
import '@assistant-ui/react/styles/modal.css';

Smartlook.init(envConfig.smartlookKey);
Smartlook.record({
  forms: true, // Enable form tracking
  numbers: true, //  Do not Mask numbers
  emails: true, // Do not mask emails
});

const UNIFIED_VIEW_SCRIPT_ID = 'fleetpanda-unified-view-script';

function UnifiedViewScript() {
  const [isUnifiedViewEnabled] = useHasSettings(FEATURE_FLAG.UNIFIED_VIEW_FEATURE);

  useEffect(() => {
    const existingScript = document.getElementById(UNIFIED_VIEW_SCRIPT_ID);

    if (!isUnifiedViewEnabled) {
      existingScript?.remove();
      return;
    }

    if (existingScript) return;

    const script = document.createElement('script');
    script.id = UNIFIED_VIEW_SCRIPT_ID;
    script.src = 'https://cdn.fleetpanda.com/shell/unified-view.js';
    script.dataset.currentApp = 'dispatch';
    script.defer = true;
    document.body.appendChild(script);
  }, [isUnifiedViewEnabled]);

  return null;
}

export function App() {
  return (
    <AppProvider>
      <UnifiedViewScript />
      <AppRoutes />
      <SonnerToaster position="top-center" richColors />
      <ToastContainer />
    </AppProvider>
  );
}
